import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Download from './shared/Download';
import Toggle from './shared/Toggle';
import {
  ANALYTICS_PAGE_NAMES,
  trackClickedActionEvent,
} from '../Common/Analytics/utils';
import { usePageViewTracking, useQuery } from '../Common/Hooks';
import { navigateToAndroidSettings, onClose } from './KindredAndroid';
import i18n from 'i18next';
import timIcon from '../Assets/PartnerNewpluginsdkActivate/tim-ios-logo.png';
import { Helmet } from 'react-helmet';
import '../Theming/Fonts/custom-fonts.css';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #0033a1;
  padding: 27px 0 0 0;
  font-family: TIMSans-Regular;
`;

const Header = styled.header`
  padding-inline: 42px;
  height: 40vh;
  padding-bottom: 30px;
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #fff;
  margin-bottom: 40px;
`;

const DisclosureContainer = styled.div`
  overflow: auto;
  height: 80%;
  -webkit-mask-image: -webkit-gradient(
    linear,
    left 70%,
    left bottom,
    from(rgba(0, 0, 0, 1)),
    to(rgba(0, 0, 0, 0))
  );
  scrollbar-color: #fff #fff;
  padding-bottom: 40px;
`;

const Disclosure = styled.p`
  color: #fff;
  margin: 0;
  font-size: 16px;
  padding-bottom: 15px;
`;

const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #0058ef;
  padding-block: 21px;
  padding-inline: 16px;
  justify-content: space-around;
  position: absolute;
  bottom: 0;
  height: 50%;
  width: 100%;
`;

const FooterTitle = styled.p`
  margin: 0;
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
`;

const ActivationStep = styled.div`
  text-align: center;
  font-size: 16px;
  color: #fff;
  align-items: center;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 20px;
`;

const Button = styled.button`
  height: 52px;
  font-size: 16px;
  font-weight: bold;
  font-family: TIMSans-Regular;

  &.white {
    background-color: #fff;
    border: none;
    color: #0164f2;
  }

  &.outlined {
    background-color: transparent;
    border: 3px solid #fff;
    color: #fff;
    margin-top: 8px;
  }
`;

const AndroidAccessibility = () => {
  if (i18n.language != 'it') {
    i18n.changeLanguage('it');
  }
  const { t } = useTranslation();
  const query = useQuery();

  usePageViewTracking(
    ANALYTICS_PAGE_NAMES.accessibility_instructions_page,
    'TIM'
  );
  const installationSteps = [
    'tim.tapAccept',
    'tim.tapInstalledApps',
    'tim.activateTimCoupon',
  ];

  const onAccept = () => {
    trackClickedActionEvent(
      query,
      'TIM',
      'agree',
      ANALYTICS_PAGE_NAMES.accessibility_instructions_page
    );
    navigateToAndroidSettings();
  };

  const onDecline = () => {
    trackClickedActionEvent(
      query,
      'TIM',
      'disagree',
      ANALYTICS_PAGE_NAMES.accessibility_instructions_page
    );
    if (window?.history?.length > 2) {
      window?.history?.go(-2);
    }
  };

  return (
    <Container>
      <Helmet>
        <link rel="icon" type="image/png" sizes="16x16" href={timIcon} />
        <title>TIM Benefit</title>
      </Helmet>
      <Header>
        <Title>{t('tim.enableAccessibilityPermissions')}</Title>
        <DisclosureContainer>
          <Disclosure>
            <Trans i18nKey="tim.accessibilityDisclosure">
              <Disclosure></Disclosure>
              <li></li>
            </Trans>
          </Disclosure>
        </DisclosureContainer>
      </Header>
      <Footer>
        <FooterTitle>{t('tim.howToActivate')}</FooterTitle>
        {installationSteps?.map((key, index) => (
          <ActivationStep key={`${key}-${index}`}>
            <Trans i18nKey={key}>
              <Download style={downloadIconStyle} />
              <Toggle style={toggleIconStyle} />
            </Trans>
          </ActivationStep>
        ))}
        <ButtonsContainer>
          <Button onClick={onAccept} className="white">
            {t('tim.accept')}
          </Button>
          <Button onClick={onDecline} className="outlined">
            {t('tim.decline')}
          </Button>
        </ButtonsContainer>
      </Footer>
    </Container>
  );
};

const toggleIconStyle: React.CSSProperties = {
  transform: 'translateY(25%)',
};

const downloadIconStyle: React.CSSProperties = {
  marginLeft: 7,
  transform: 'translateY(25%)',
};

export default AndroidAccessibility;
